import { recipesQuery, SearchQuery } from '@/api/recipes'
import { Spinner } from '@/components/Spinner'
import {
  Cell,
  Column,
  Row,
  Table,
  TableBody,
  TableHeader,
  TablePagination,
  TableSearch,
} from '@/components/Table'
import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onSelectionChange: ({ idRecipe, name }: { idRecipe: number; name: string }) => void
}

export default function RecipeSelector({ onSelectionChange }: Props) {
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>({
    page: 0,
    searchText: '',
  })
  const { data, isLoading } = useQuery(recipesQuery(searchQuery)) //TODO improve fetch all recipes
  const recipes = data?.data ?? []
  const totalCount = parseInt(data?.headers['x-result-count'] ?? '0')

  const handleSearch = (text: string) => {
    setSearchQuery({ ...searchQuery, searchText: text, page: 0 })
  }

  const handleSelectionChange = (items: number[]) => {
    if (items.length > 0) {
      const recipe = recipes.find((r) => r.idRecipe === items[0])
      if (recipe) {
        onSelectionChange({ idRecipe: recipe.idRecipe, name: recipe.name })
      }
    }
  }

  return (
    <div>
      {isLoading ? (
        <div style={{ minHeight: 400 }}>
          <Spinner />
        </div>
      ) : (
        <div className="RecipeIndexTable">
          <TableSearch handleSearch={handleSearch} defaultValue={searchQuery.searchText} />
          <Table
            aria-label="Recipes table"
            selectionMode="single"
            onSelectionChange={(items) => handleSelectionChange([...items] as number[])}>
            <TableHeader>
              <Column id="name" isRowHeader>
                {t('recipe.name')}
              </Column>
            </TableHeader>
            <TableBody items={recipes}>
              {(recipe) => (
                <Row id={recipe.idRecipe}>
                  <Cell>{recipe.name}</Cell>
                </Row>
              )}
            </TableBody>
          </Table>
          <TablePagination
            pagination={{
              totalCount: totalCount,
              page: searchQuery.page ?? 0,
              setPage: (page) => {
                setSearchQuery({ ...searchQuery, page })
              },
            }}
          />
        </div>
      )}
    </div>
  )
}
